import moment from "moment";

export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 }
];

export const initialFilter = {
  filter: {
    name: ""
  },
  pageNumber: 1,
  pageSize: 10
};

export const initValue = {
  name: "",
  target_revenue: "",
  begin_date: "",
  end_date: "",
  description: "",
  latitude: "",
  longitude: ""
};

export function getProjectInitialValues(project) {
  const {
    uuid = "",
    district = "",
    city = "",
    province = "",
    begin_date = "",
    end_date = "",
    branch_uuid = "",
    name = "",
    description = "",
    organization = "",
    program = [],
    target_revenue = "",
    latitude = "",
    longitude = ""
  } = project ?? {};

  const values = {
    uuid: uuid ?? "",
    district: district ?? "",
    city: city ?? "",
    province: province ?? "",
    begin_date: begin_date ?? moment(),
    end_date: end_date ?? moment().add(1, "month"),
    branch_uuid: branch_uuid ?? "",
    name: name ?? "",
    description: description ?? "",
    organization: organization ?? "",
    program: program ?? [],
    target_revenue: target_revenue ?? "",
    latitude: latitude ?? "",
    longitude: longitude ?? ""
  };

  return values;
}
